/* eslint-disable no-console */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useContext } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../../libs/Context';
import NotFoundImage from '../../assets/NoDataImages/notFound_img.svg';
import { useSelector } from 'react-redux';

function PageNotFound()
{
	const path = window.location.pathname;
	const navigation = useNavigate();
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state) => state?.mysession?.session);

	function openPageNotfnd()
	{
		if ([ '/contractManagement', '/productWarranty' ].includes(path))// to stop  showing until the entire userData keys are set
		{
			return Boolean(Object.keys(userData)?.length > 14);
		}
		else { return true; }
	}

	return (
		<>
			{openPageNotfnd() &&
			<div className='flexCol justifyCntr alignCntr fullVirtualHeight'>
				<div className='flexInline alignCntr justifyCntr'>
					<span className='icon-notFound_img--1 nodatafont'><span className='path1' /><span className='path2' /><span className='path3' /><span className='path4' /><span className='path5' /><span className='path6' /><span className='path7' /><span className='path8' /><span className='path9' /><span className='path10' /><span className='path11' /><span className='path12' /><span className='path13' /><span className='path14' /><span className='path15' /></span>

				</div>
				<div className='flexCol alignCntr pdngSM'>
					<h3 className='textCntr mrgnBtmSM'>{language?.pageNotFound}</h3>
					<span className='textCntr'>
						{language?.oopsWarning}{"'"}{language?.tryingSearchNotFound}
					</span>
					<button
						tabIndex={0}
						onKeyUp={(e) =>
						{
							e.key === 'Enter' &&
						navigation('/news');
						}}
						className='flexInline pdngVMD'
						onClick={() =>
						{
							navigation('/news');
						}}
					>
						<Button disableElevation disableRipple className='link' variant='outlined'>{language?.goToNews}</Button>
					</button>
				</div>
			</div>}
		</>
	);
}
export default PageNotFound;
